import React from 'react';

// ★ Item-5 READER (walk-minimal) — the whole-model empty state.
//
// A DISPLAY-ONLY reader over records the engines ALREADY produce. When a
// mid-onboarding tenant is missing a foundational input, runFullModel /
// orchestrator return empty statements and ModelProvider derives a single
// `onboardingGap` from the fail-loud records (missingCloseMonth /
// missingChartOfAccounts) plus the no-forecast-horizon fetch-path early return
// (the filed DEFECT-A hang). The four statement pages early-return this instead
// of rendering empty tables — or, for the no-horizon case, a permanent spinner.
//
// No engine call, no result field, no number: this only names a gap the engines
// already reported. Fully-wired tenants (cid=1/2/3) have every record empty →
// onboardingGap is null → this never renders.

const FONT = "'DM Sans',-apple-system,sans-serif";

// Copy is Brian-approved verbatim; keyed by gap kind. no_horizon shares Step 1
// with no_close_month (a missing Forecast Through is a Step-1 Company Setup field).
const COPY = {
  no_close_month: "No close month set yet — the model can't tell actuals from forecast, so no statements were computed. Set the Historical Start, Last Closed Month, and Forecast Through in Step 1 (Company Setup).",
  no_horizon: "No close month set yet — the model can't tell actuals from forecast, so no statements were computed. Set the Historical Start, Last Closed Month, and Forecast Through in Step 1 (Company Setup).",
  no_chart_of_accounts: "No chart of accounts yet — the balance sheet and cash flow can't be built without it, and another company's chart is never a substitute. Upload your financials in Step 2 (IS & BS Upload) and confirm the accounts through Step 4 (Review Financials).",
};

const TITLE = {
  no_close_month: "Finish onboarding to see the model",
  no_horizon: "Finish onboarding to see the model",
  no_chart_of_accounts: "Finish onboarding to see the model",
};

export default function OnboardingIncomplete({ gap }) {
  const kind = gap && gap.kind;
  const message = COPY[kind] || COPY.no_close_month;
  const title = TITLE[kind] || TITLE.no_close_month;
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: '60vh', padding: '60px 24px', textAlign: 'center', fontFamily: FONT,
    }}>
      <div style={{
        maxWidth: 520, background: '#fff', border: '1px solid rgba(0,0,0,0.08)',
        borderRadius: 14, padding: '32px 36px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
      }}>
        <div style={{ fontSize: 34, marginBottom: 14 }} aria-hidden="true">🧭</div>
        <div style={{ fontSize: 17, fontWeight: 700, color: '#1A1C2E', marginBottom: 10 }}>{title}</div>
        <div style={{ fontSize: 13, lineHeight: 1.6, color: '#4A4E69' }}>{message}</div>
        <div style={{ fontSize: 11, color: '#8B8FA3', marginTop: 18 }}>
          Onboarding is under Admin. Once these are set, this page fills in automatically.
        </div>
      </div>
    </div>
  );
}
